// src/components/Badge.jsx
import React from "react";

const cx = (...c) => c.filter(Boolean).join(" ");

const badgeSizes = {
  xsmall: "px-[4px] py-[2px] gap-[10px] text-c3", // 확정 스펙 유지
};

export function Badge({
  children,
  size = "xsmall", //기본값: xsamll
  disabled = false,
  className = "",
  ...props
}) {
  const sizeClass = badgeSizes[size] || badgeSizes.xsmall;

  const baseClass = "bg-surface-primary-dimmed_60 text-text-inverse";

  return (
    <span
      className={cx(
        "inline-flex items-center rounded-full whitespace-nowrap",
        sizeClass,
        baseClass,
        disabled,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
